export const TABLE_OF_CONTENT_ID = 'table-of-content-container';
export const TRANSITION_DELAY = 300; // 0.3 sec
export const HEADER_OFFSET = 50;
export const HEADER_TOP_COMPENSATION = 10;
